import { SharedGridPadding } from "features/CenterContent/shared/MainContentGrid";
import { getTrainSemantic } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/TrainStop/utils";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DropsBadge, Flex, Text } from "shared/components/Spor";

type DelayBadgeProps = {
  delay: number | null;
};
const DelayBadge: FC<DelayBadgeProps> = ({ delay }) => {
  const { t } = useTranslation();
  if (delay === null) return null;
  if (delay < 0)
    return (
      <DropsBadge semantics="info">
        {Math.abs(delay)} {t("min for tidlig")}
      </DropsBadge>
    );
  if (delay === 0) return <DropsBadge semantics="neutral">I rute</DropsBadge>;
  return (
    <DropsBadge semantics={getTrainSemantic({ delay }) ?? "neutral"}>
      {delay} {t("min forsinket")}
    </DropsBadge>
  );
};

type TrainRouteHeaderProps = {
  delay: number | null;
};
export const TrainRouteHeader: FC<TrainRouteHeaderProps> = ({ delay }) => {
  const { t } = useTranslation();
  return (
    <Flex justifyContent="space-between" w="100%" p={SharedGridPadding}>
      <Text variant="sm" fontWeight={600} mr="auto">
        {t("Trasé")}
      </Text>
      <DelayBadge delay={delay} />
    </Flex>
  );
};
